import React from 'react';
import { UnitsRouter } from '../../../routes';
import { Property } from '../../../../types/generated-types';

export function PropertyUnits({ data: property }: { data: Partial<Property> }) {
  return <UnitsRouter />;
}
